import React from "react";
import { useAuth } from "../context/AuthContext";
export default function BillPrintLayout({data}) {
    const { user } = useAuth();
    if(!data) return null;
    const products = data?.products || [];
    const subtotal = Number(data?.subtotal ?? data?.subTotal ?? 0);
    const totalGst = Number(data?.totalGst ?? data?.calculated_GST ?? 0);
    const grandTotal = Number(data?.grandTotal ?? data?.total_bill_amount ?? 0);
    const tableId = data?.tableId || data?.seatingName || "-";
    const clientName = data?.clientName || "Walk-In";
    const gstNumber = data?.gstNumber || "";
    const invoiceNumber = data?.invoiceNumber || data?.bill_id || "----";

    return (
        <div className="hidden print:block print-receipt-container mx-auto text-black font-mono text-xs p-1">
             {/* Header details */}
                <div className="text-center space-y-1 mb-4">

                    {/* Placeholder for Restaurant Logo wrapper asset context if setup */}
                    {user?.restaurantLogo && (
                        <img src={user.restaurantLogo} alt="Restaurant Logo" className="mx-auto h-10 w-10 object-contain" />
                    )}
                    <h1 className="text-lg font-bold uppercase tracking-tight">{user?.restaurantDisplayName || "Atithi Dhaba"}</h1>
                    <p className="text-[14px]"><strong>{user?.restaurantAddress || "Atithi Dhaba Near airport thana."}</strong></p>
                    <p className="text-[14px]"><strong>Contact: {user?.restaurantContact || "+91 9827383352"}</strong></p>
                    <p className="text-[14px]"><strong>Invoice No: {invoiceNumber}</strong></p>
                    
                </div>

                <div className="border-b border-dashed border-black my-2"></div>

                {/* Metadata details */}
                <div className="space-y-0.5 text-[11px]">
                    <div><strong>Date:</strong> {new Date().toLocaleDateString()} | {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</div>
                    <div><strong>Table ID:</strong> {tableId}</div>
                    <div><strong>Customer:</strong> {clientName}</div>
                    {gstNumber && <p className="text-[10px] font-semibold">GSTIN: <strong>{gstNumber}</strong></p>}
                </div>

                <div className="border-b border-black my-2"></div>

                {/* Items details Headers */}
                <div className="grid grid-cols-12 font-bold text-[12px] mb-1">
                    <span className="col-span-5">Item</span>
                    <span className="col-span-2 text-center">Qty</span>
                    <span className="col-span-2 text-center">Price</span>
                    <span className="col-span-3 text-right">Amount</span>
                </div>
                
                <div className="border-b border-dashed border-black mb-2"></div>

                {/* Products list items loop layout mapping */}
                <div className="space-y-1.5 text-[12px]">
                    {products?.map((item, index) => {
                        const name = item?.name || item?.productName || "Unknown Item";
                        const qty = Number(item?.quantity ?? item?.qty ?? 0);
                        const price = Number(item?.price ?? 0);

                        return (
                            <div key={item.productId || index} className="grid grid-cols-12 items-start">
                                <span className="col-span-5 line-clamp-2 break-words leading-5">{name}</span>
                                <span className="col-span-2 text-center">{qty}</span>
                                <span className="col-span-2 text-center">₹{price}</span>
                                <span className="col-span-3 text-right">₹{(qty * price).toFixed(2)}</span>
                        </div>
                        );
                    })}
                </div>

                <div className="border-b border-dashed border-black my-3"></div>
                {/* Computational Math aggregations block */}
                <div className="space-y-1 text-[12px] ml-auto max-w-[95%]">
                    <div className="flex justify-between text-[12px]">
                        <span>Subtotal:</span>
                        <span>₹{subtotal.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between text-[12px]">
                        <span>CGST:</span>
                        <span>₹{totalGst.toFixed(2)/2}</span>
                    </div>
                    <div className="flex justify-between text-[12px]">
                        <span>SGST:</span>
                        <span>₹{totalGst.toFixed(2)/2}</span>
                    </div>
                    <div className="flex justify-between font-bold border-t border-black pt-1 mt-1 text-[12px]">
                        <span>Total:</span>
                        <span>₹{Math.round(grandTotal)}</span>
                    </div>
                </div>

                <div className="border-b border-dashed border-black my-2"></div>
                <div className="text-center">
                    <strong>GST No: {user?.restaurantGSTNo || "23BWBPN8238D1ZP"}</strong>
                </div> 
                <div className="border-b border-dashed border-black my-2"></div>

                {/* Footer details */}
                <div className="text-center space-y-1 mt-2">
                    <p className="font-bold text-[12px]">Thank You! Visit Again</p>
                    <p className="text-[12px] text-gray-500 italic">Powered by RestoPOS Engine</p>
                </div>
        </div>
    );
}
